import React from 'react';
import { connect } from 'react-redux';

const OrderRowItemMore = props => {
  const { propKey, accessories, sets, order: { type: orderType, requested }  } = props;
  return (
    <div style={{display: 'flex', height: '64px', alignItems: 'center'}}>
      <div style={{width: '150px'}}></div>
      <div style={{display: 'flex'}}>
        <div style={{width: '500px', display: 'flex', alignItems: 'center', color: '#3f51b5'}}>{orderType === 'a' ? accessories[propKey].descr : sets[propKey].descr }</div>
        <div style={{width: '50px', fontWeight: 'bold'}}>
          <div>{requested[propKey]}</div>
          <div>шт</div>
        </div>
      </div>
    </div>
  );
}

export default connect()(OrderRowItemMore);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-preorder/item-more.js